import {Component, inject, Input, Output, OnDestroy, EventEmitter} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BaseService} from "../../../services/base.service";
import {HttpErrorNotifyService} from "../../../services/http-error-notify.service";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-modal-change-delivery-date',
  templateUrl: './modal-change-delivery-date.component.html',
  styleUrls: ['./modal-change-delivery-date.component.scss']
})
export class ModalChangeDeliveryDateComponent extends BaseService implements OnDestroy {
  @Input() orderId: number;
  @Input() deliveryDate: string[];
  @Input() deliveryDatesHours: { [date: string]: number[] };
  @Output() deliveryDateUpdated = new EventEmitter();

  private http = inject(HttpClient);
  private notify = inject(HttpErrorNotifyService);

  public isDestroyed: Subject<boolean> = new Subject();
  public selectedDate = -1;
  public selectedHours = -1;
  public wrongDeliveryDates = false;
  public wrongDeliveryHours = false;
  public isValidDeliveryForm = false;
  public showDeliveryDate = false;
  public isDarkBackground = false;
  private isUserChangedDeliveryDate = false;
  public deliveryHoursList: number[] = [];

  modalShow() {
    // модалка одна на всі замовлення: без скидання дата/година, обрані для замовлення A,
    // лишались у моделі (select їх не показує, якщо у B інший список) і йшли на замовлення B
    this.selectedDate = -1;
    this.selectedHours = -1;
    this.deliveryHoursList = [];
    this.wrongDeliveryDates = false;
    this.wrongDeliveryHours = false;
    this.isValidDeliveryForm = false;
    this.isUserChangedDeliveryDate = false;

    this.showDeliveryDate = true;
    this.isDarkBackground = true;
  }

  changeDeliveryDate() {
    this.isUserChangedDeliveryDate = true;
    this.validationDeliveryDate();
  }

  validationDeliveryDate() {
    if (this.selectedDate == -1) {
      this.wrongDeliveryDates = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryDates = false;
      this.isValidDeliveryForm = false;
    }

    if (this.selectedDate != -1 && this.deliveryDatesHours && this.deliveryDatesHours[this.selectedDate]) {
      this.deliveryHoursList = this.deliveryDatesHours[this.selectedDate];
    } else {
      this.deliveryHoursList = [];
    }

    if (this.isUserChangedDeliveryDate) {
      this.selectedHours = -1;
      this.wrongDeliveryHours = false;
      this.isUserChangedDeliveryDate = false;
    }
  }

  validationDeliveryHours() {
    if (!this.deliveryHoursList?.length) {
      this.wrongDeliveryHours = false;
      return;
    }

    if (this.selectedHours == -1) {
      this.wrongDeliveryHours = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryHours = false;
    }
  }

  submitDeliveryDate() {
    if (!this.selectedDate || !this.orderId || !this.deliveryDate) return;

    this.validationDeliveryDate();
    this.validationDeliveryHours();

    if (!this.isValidDeliveryForm) {
      let hour: string | number = '';

      if (this.deliveryHoursList?.length && this.selectedHours !== -1) {
        hour = this.selectedHours;
      }

    this.http.post(this.apiRoot + 'orders_history/update_delivery_date', {
      order_id: this.orderId,
      date_delivery: this.selectedDate,
      delivery_hour: hour,
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((resp: any) => {
        // Бек відмовляє зі статусом 200 (замовлення вже не «Нове», невірна дата) - раніше модалка
        // закривалась як після успіху, і стара дата в списку лишалась без пояснень
        if (!resp || resp.data !== 'success') {
          this.notify.show('Дату доставки не змінено', this.describeDateError(resp));
        }

        // список перечитуємо в обох випадках: при відмові в ньому вже актуальний статус
        this.deliveryDateUpdated.emit();

        this.closeModal();
      });
    }
  }

  private describeDateError(resp: any): string {
    if (resp && resp.error === 'The delivery date can only be changed for orders with status New.') {
      return 'Дату можна змінити лише для замовлення у статусі «Новий». Статус замовлення вже змінився.';
    }

    if (resp && resp.error === 'Wrong delivery date.') {
      return 'Невірна дата доставки. Оберіть дату зі списку.';
    }

    return 'Спробуйте ще раз. Якщо помилка повториться - зверніться до менеджера.';
  }

  closeModal() {
    this.showDeliveryDate = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    // takeUntil реагує лише на next(), complete() запит у роботі не скасовує
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
